var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F9F9F9",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1737 31.8043C32.1017 33.7372 33.3667 35.5487 34.9689 37.1508C36.571 38.7529 38.3825 40.018 40.3153 40.946C40.4816 41.0258 40.5647 41.0657 40.6699 41.0963C41.0437 41.2053 41.5027 41.127 41.8193 40.9004C41.9083 40.8366 41.9846 40.7604 42.137 40.6079C42.6031 40.1418 42.8362 39.9087 43.0706 39.7564C43.9544 39.1817 45.0938 39.1817 45.9777 39.7564C46.2121 39.9087 46.4451 40.1418 46.9113 40.608L47.1711 40.8678C47.8797 41.5764 48.234 41.9307 48.4265 42.3112C48.8092 43.0679 48.8092 43.9616 48.4265 44.7184C48.234 45.0989 47.8797 45.4532 47.1711 46.1617L46.9609 46.3719C46.2548 47.0781 45.9017 47.4312 45.4216 47.7008C44.889 48.0001 44.0616 48.2152 43.4507 48.2134C42.9001 48.2118 42.5238 48.1049 41.7712 47.8913C37.7267 46.7434 33.9102 44.5774 30.7262 41.3934C27.5422 38.2095 25.3763 34.393 24.2283 30.3485C24.0147 29.5959 23.9079 29.2196 23.9063 28.669C23.9044 28.058 24.1196 27.2307 24.4188 26.698C24.6885 26.218 25.0416 25.8649 25.7477 25.1587L25.9579 24.9485C26.6665 24.24 27.0208 23.8857 27.4013 23.6932C28.1581 23.3104 29.0517 23.3104 29.8085 23.6932C30.189 23.8857 30.5433 24.24 31.2519 24.9485L31.5117 25.2084C31.9778 25.6745 32.2109 25.9076 32.3633 26.142C32.938 27.0258 32.938 28.1652 32.3633 29.0491C32.2109 29.2835 31.9778 29.5165 31.5117 29.9827C31.3593 30.1351 31.2831 30.2113 31.2193 30.3004C30.9926 30.617 30.9143 31.076 31.0233 31.4498C31.054 31.555 31.0939 31.6381 31.1737 31.8043Z",
    stroke: "#FF7EB8",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.300897e25985018eead6a2d38e04fbc4.svg";
export { ForwardRef as ReactComponent };